// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1Iopq","head":"ProcedureTableInfo_head__gKhjJ"};